import { defineStore } from "pinia"

export const useAlertDialog = defineStore("alertDialog", () => {
  const alertDialogShow = ref(false)
  const alertDialogMessage = ref("")
  const alertDialogTitle = ref("")
  const alertDialogTimeout = ref(0)

  function showAlertDialog  (pMessage, pTitle="", pTimeout = 0) {
    alertDialogMessage.value = pMessage
    alertDialogTitle.value = pTitle
    alertDialogTimeout.value = pTimeout

    if(pTimeout != 0) {
      setTimeout(() => {
        alertDialogShow.value = false
      }, pTimeout)
    }
    alertDialogShow.value = true
  }

  return { alertDialogShow, alertDialogMessage, alertDialogTitle, alertDialogTimeout, showAlertDialog }
})
